module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "floor-list"
  }, _vm._l((_vm.curZone.wayItemInfoVOList), function(layer, layerIndex) {
    return _c('div', {
      key: layerIndex,
      staticClass: "floor-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(layer.layerInfo))]), _vm._v(" "), _c('div', {
      staticClass: "floor-product-list"
    }, _vm._l((layer.wayItemVOList), function(item, productIndex) {
      return _c('div', {
        key: productIndex,
        staticClass: "item"
      }, [_c('div', {
        staticClass: "item-img"
      }, [_c('img', {
        attrs: {
          "src": item.mainPicView,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "item-info"
      }, [_c('div', {
        staticClass: "p1"
      }, [_vm._v("货道" + _vm._s(item.wayCode))]), _vm._v(" "), _c('div', {
        staticClass: "p2"
      }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
        staticClass: "p3"
      }, [_vm._v("¥" + _vm._s(item.displayPrice != null ? item.displayPrice : item.specialPrice))])])])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "fixed-btn-box"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("确定" + _vm._s(_vm.descpName) + " "), _c('span', [_vm._v("(" + _vm._s(_vm.descpName) + "后，请关门盘点库存)")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fdd9f40","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/supplyRecord/supplyCompare.vue
// module id = 2MiC
// module chunks = 51